import { render, staticRenderFns } from "./Combination.vue?vue&type=template&id=b2930f72"
import script from "./Combination.vue?vue&type=script&lang=js"
export * from "./Combination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports